import { ReactElement, useEffect } from 'react';
import styles from './emergency-broadcast-page.module.scss';
import { useUINav } from '@/ui';
import { Navigate } from 'react-router';
import { useCompanyPermissions } from '@/companies/hooks';
import { SendEmergencyBroadcast } from '@/broadcast/components';
import { usePagesTranslation } from '../hooks';
import { NoAccessMask } from '@/tasks/components';

export function EmergencyBroadcastPage(): ReactElement {
    const { setParts } = useUINav();

    const { t } = usePagesTranslation();

    useEffect(() => {
        setParts([{ text: t('pages.emergency_broadcast.title') }]);
    }, [setParts, t]);

    const { canViewEmergencyBroadcast } = useCompanyPermissions();

    if (!canViewEmergencyBroadcast) {
        return <Navigate to="/" replace />;
    }

    return <Content />;
}

function Content(): ReactElement {
    const { hasSubscription, hasLicense } = useCompanyPermissions();
    return (
        <div className={styles.container}>
            <SendEmergencyBroadcast />
            {!hasSubscription && <NoAccessMask withMessage="no-subscription" />}
            {hasSubscription && !hasLicense && (
                <NoAccessMask withMessage="no-license" />
            )}
        </div>
    );
}
